export abstract class BaseModel<ResourceKey extends string> {
  public abstract setLoadingByKey(loadingByKey: Record<ResourceKey, boolean>): void;
  public abstract clearError(key: ResourceKey): void;
  public abstract setError(key: ResourceKey, message: string): void;
}
